export default __webpack_public_path__ + "static/media/bg.a7ef9293.webp";